import type { ConditionalLayoutSpecRule } from '../conditionalLayoutSpecs';

export const MONITORING_CONDITIONAL_LAYOUT_SPEC_RULES = {} satisfies Record<string, ConditionalLayoutSpecRule>;
